import React from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'components/ui/Modal';
import AlertBox from 'components/ui/AlertBox';
import { FormattedMessage } from 'react-intl';

function BookingEmailFailed({ isOpen, onClose }) {
  return (
    <Modal
      alert={
        <AlertBox variant={AlertBox.variants.ERROR}>
          <FormattedMessage id="afterSales.sendBookingConfirmation.error" />
        </AlertBox>
      }
      title={<FormattedMessage id="afterSales.sendBookingConfirmation.failedToSend" />}
      subtitle={<FormattedMessage id="afterSales.sendBookingConfirmation.pleaseTryAgain" />}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}

BookingEmailFailed.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default BookingEmailFailed;
